// import React, { useEffect, useState } from "react";
// import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
// import NoData from "../../NoData";
// import ChartLoader from '../../ChartLoader';
// import CommanBarTable_Orion from "../CommanBarTable_Orion";
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import WaterMark from "../../DashboardMain_Orion/WaterMark";
// import { BsZoomIn } from "react-icons/bs";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   scales,
//   Ticks
// } from "chart.js";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );
// let Maxchartdata
// let res_result = []

// function MaxCellTemp_vehicles_Orion({ apiend, gloablfilter, type, chartnameFCD, maxCellTemp_Option }) {
//   const [chartdata, setChartData] = useState([]);
//   const [apiresponce, SetApiResponce] = useState([]);
//   const [filteredData, SetfilteredData] = useState([]);
//   const { isLoading, error, sendReq: fetchData } = useHttp();
//   const [chartname, SetChartName] = useState(chartnameFCD);
//   let barcolor = "#83A4CF"

//   const appyDataVehicles = (data) => {
//     res_result = []
//     res_result = data;
//     let responce = {
//       "<=20": 0,
//       "22": 0,
//       "24": 0,
//       "26": 0,
//       "28": 0,
//       "30": 0,
//       "32": 0,
//       "34": 0,
//       "36": 0,
//       "38": 0,
//       "40": 0,
//       "42": 0,
//       "44": 0,
//       ">44": 0,
//     };
//     if (res_result.length !== 0) {
//       let temp_result = res_result;
//       let id = 0
//       let newapiarray = []
//       SetApiResponce(res_result)
//       temp_result.map(d => {
//         let value = d[maxCellTemp_Option].value;
//         if (value != null) {
//           if (value > 0 && value <= 20) {
//             responce["<=20"] = responce["<=20"] + 1;
//           } else if (value > 20 && value <= 22) {
//             responce["22"] = responce["22"] + 1;
//           } else if (value > 22 && value <= 24) {
//             responce["24"] = responce["24"] + 1;
//           } else if (value > 24 && value <= 26) {
//             responce["26"] = responce["26"] + 1;
//           } else if (value > 26 && value <= 28) {
//             responce["28"] = responce["28"] + 1;
//           } else if (value > 28 && value <= 30) {
//             responce["30"] = responce["30"] + 1;
//           } else if (value > 30 && value <= 32) {
//             responce["32"] = responce["32"] + 1;
//           } else if (value > 32 && value <= 34) {
//             responce["34"] = responce["34"] + 1;
//           } else if (value > 34 && value <= 36) {
//             responce["36"] = responce["36"] + 1;
//           } else if (value > 36 && value <= 38) {
//             responce["38"] = responce["38"] + 1;
//           } else if (value > 38 && value <= 40) {
//             responce["40"] = responce["40"] + 1;
//           } else if (value > 40 && value <= 42) {
//             responce["42"] = responce["42"] + 1;
//           } else if (value > 42 && value <= 44) {
//             responce["44"] = responce["44"] + 1;
//           } else if (value > 44) {
//             responce[">44"] = responce[">44"] + 1;
//           }
//         }
//       })

//       let res_result_final = [["Element", "Count", { role: "style" }]]
//       const loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
//       let countcheck = 0
//       for (const key in responce) {
//         if (responce[key] > 0) {
//           countcheck = countcheck + 1
//         }
//       }

//       loop_keys.map(x => {
//         if (countcheck)
//           // "#83A4CF"
//           res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
//       })

//       const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
//       Maxchartdata = {
//         labels,
//         datasets: [
//           {
//             label: "deg Celcius",
//             data: responce,
//             backgroundColor: barcolor,
//             borderWidth: 1,
//             borderColor: "black",
//           },
//         ]
//       };
//       setChartData((prestate) => res_result_final);
//     } else {
//       setChartData((prestate) => []);
//     }
//   }

//   const options1 = {
//     responsive: true,
//     categoryPercentage: 1.0,
//     barPercentage: 1.0,
//     scales: {
//       x: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'deg Celcius'
//         },
//         suggestedMin: 0,
//         ticks: {
//           autoSkip: false,
//           maxRotation: 0,
//           minRotation: 0,
//         }
//       },

//       y: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Vehicle Count'
//         },
//         suggestedMin: 0,
//       },
//     },

//     plugins: {
//       legend: {
//         display: false
//       },
//     }
//   }

//   const options = {
//     hAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'deg Celcius',
//       minValue: 0,
//       format: 'short',
//       direction: 1,
//       slantedText: true,
//       slantedTextAngle: 90,
//     },

//     vAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Vehicle Count',
//       minValue: 0,
//       format: 'short',
//     },
//     bar: { groupWidth: "100%" },
//     legend: "none",
//     isStacked: false,
//     series: {
//       0: { color: "#83A4CF" },
//     },
//   };

//   const [tempMaxTemp, setTempMaxTemp] = useState("")
//   useEffect(() => {
//     setTempMaxTemp(maxCellTemp_Option)
//     SetfilteredData([])
//     barcolor = "#83A4CF"
//     SetChartName(chartnameFCD);
//     fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter, maxCellTemp_Option: maxCellTemp_Option } }, appyDataVehicles)
//   }, [gloablfilter, type, maxCellTemp_Option])

//   return (
//     <>
//       <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
//               {
//                 (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
//                   : <NoData />
//                 )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
//       <WaterMark />

//       {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
//         {
//           eventName: 'select',
//           callback: ({ chartWrapper }) => {
//             const chart = chartWrapper.getChart()
//             const selection = chart.getSelection()
//             if (selection.length === 1) {
//               const [selectedItem] = selection;
//               const { row } = selectedItem;

//               const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
//               const count = chartWrapper.getDataTable().Wf[row].c[1].v;

//               let filtered_temp = [];
//               if (count !== 0) {
//                 filtered_temp = apiresponce.filter(x => {
//                   if (x[tempMaxTemp].value <= barvalue && x[tempMaxTemp].value > barvalue - 2) {
//                     return x;
//                   }
//                   else if (x[tempMaxTemp].value > 44 && barvalue === ">44") {
//                     return x
//                   }
//                   else if (x[tempMaxTemp].value <= 20 && barvalue === "<=20") {
//                     return x
//                   }
//                 })

//                 function compareObjects(object1, object2, key) {
//                   let obj1 = 0
//                   let obj2 = 0
//                   obj1 = object1[tempMaxTemp].value
//                   obj2 = object2[tempMaxTemp].value
//                   if (obj1 > obj2) {
//                     return -1
//                   }
//                   if (obj1 < obj2) {
//                     return 1
//                   }
//                   return 0
//                 }

//                 filtered_temp.sort((value1, value2) => {
//                   return compareObjects(value1, value2, 'value')
//                 })
//                 SetfilteredData(prestate => filtered_temp);
//                 window.$('#exampleModal__' + apiend).modal('show');
//               }
//             }
//           }
//         }
//       ]}
//       /> : <NoData />)}

//       <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
//             <div className="modal-body">
//               {/* <table className="table table-striped">
//                 <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
//                   <tr>
//                     <th scope="col">Vin Number</th>
//                     <th scope="col">Value</th>
//                   </tr></thead>
//                 <tbody> */}
//               <CommanBarTable_Orion data={filteredData} tabDataKey={tempMaxTemp} noFifty="noFifty" />
//               {/* </tbody></table> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default MaxCellTemp_vehicles_Orion;

import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import CommanBarTable_Orion from "../CommanBarTable_Orion";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result = []

function MaxCellTemp_vehicles_Orion({ apiend, gloablfilter, type, chartnameFCD, maxCellTemp_Option }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor = "#83A4CF"

  const appyDataVehicles = (data) => {
    res_result = []
    res_result = data;
    // ---------- UPDATED BIN CONFIG (size 4) ----------
    let responce = {
      "<=20": 0,
      "20-24": 0,
      "24-28": 0,
      "28-32": 0,
      "32-36": 0,
      "36-40": 0,
      "40-44": 0,
      ">44": 0,
    };
    // --------------------------------------------------
    if (res_result.length !== 0) {
      let temp_result = res_result;
      let id = 0
      let newapiarray = []
      SetApiResponce(res_result)
      temp_result.map(d => {
        let value = d[maxCellTemp_Option].value;
        if (value != null) {
          // ---------- UPDATED BIN ASSIGNMENT (size 4) ----------
          if (value > 0 && value <= 20) {
            responce["<=20"] = responce["<=20"] + 1;
          } else if (value > 20 && value <= 24) {
            responce["20-24"] = responce["20-24"] + 1;
          } else if (value > 24 && value <= 28) {
            responce["24-28"] = responce["24-28"] + 1;
          } else if (value > 28 && value <= 32) {
            responce["28-32"] = responce["28-32"] + 1;
          } else if (value > 32 && value <= 36) {
            responce["32-36"] = responce["32-36"] + 1;
          } else if (value > 36 && value <= 40) {
            responce["36-40"] = responce["36-40"] + 1;
          } else if (value > 40 && value <= 44) {
            responce["40-44"] = responce["40-44"] + 1;
          } else if (value > 44) {
            responce[">44"] = responce[">44"] + 1;
          }
          // -------------------------------------------------------
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      // ---------- UPDATED loop_keys and labels ----------
      const loop_keys = ["<=20", "20-24", "24-28", "28-32", "32-36", "36-40", "40-44", ">44"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          // "#83A4CF"
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["<=20", "20-24", "24-28", "28-32", "32-36", "36-40", "40-44", ">44"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "deg Celcius",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'deg Celcius'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'deg Celcius',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  const [tempMaxTemp, setTempMaxTemp] = useState("")
  useEffect(() => {
    setTempMaxTemp(maxCellTemp_Option)
    SetfilteredData([])
    barcolor = "#83A4CF"
    SetChartName(chartnameFCD);
    fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter, maxCellTemp_Option: maxCellTemp_Option } }, appyDataVehicles)
  }, [gloablfilter, type, maxCellTemp_Option])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              // Google Chart returns the label string in column 0 (per your confirmation)
              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;

              let filtered_temp = [];
              if (count !== 0) {
                // ---------- Use the label string to determine min/max for filtering ----------
                const label = barvalue;
                let min = 0, max = 999;

                if (label === "<=20") {
                  min = 0; max = 20;
                } else if (label === "20-24") {
                  min = 20; max = 24;
                } else if (label === "24-28") {
                  min = 24; max = 28;
                } else if (label === "28-32") {
                  min = 28; max = 32;
                } else if (label === "32-36") {
                  min = 32; max = 36;
                } else if (label === "36-40") {
                  min = 36; max = 40;
                } else if (label === "40-44") {
                  min = 40; max = 44;
                } else if (label === ">44") {
                  min = 44; max = 999;
                }

                filtered_temp = apiresponce.filter(x => {
                  const val = x[tempMaxTemp].value;
                  if (val == null) return false;
                  // match the same inclusive/exclusive edges as bin definition
                  if (label === "<=20") {
                    return val > 0 && val <= 20;
                  }
                  if (label === ">44") {
                    return val > 44;
                  }
                  return (val > min && val <= max);
                })

                function compareObjects(object1, object2, key) {
                  let obj1 = 0
                  let obj2 = 0
                  obj1 = object1[tempMaxTemp].value
                  obj2 = object2[tempMaxTemp].value
                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
            <div className="modal-body">
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">Value</th>
                  </tr></thead>
                <tbody> */}
              <CommanBarTable_Orion data={filteredData} tabDataKey={tempMaxTemp} noFifty="noFifty" />
              {/* </tbody></table> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxCellTemp_vehicles_Orion;
